import { Component, OnInit, Input, Output, EventEmitter, ViewChild, forwardRef } from '@angular/core';
import { FormGroup, FormControl, ReactiveFormsModule } from '@angular/forms';
import { 
    IonSpinner, IonGrid, IonRow, IonCol,
    InfiniteScrollCustomEvent, IonInfiniteScroll,  IonInfiniteScrollContent 
} from '@ionic/angular/standalone';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { MarvButtonComponent, MarvDrawerComponent, MarvCircleComponent, MarvMessageComponent, MarvInputComponent } from '@marv/components';
import { StoreItemComponent, StoreFiltersComponent, StoreFiltersValues, StoreItem, TypeMissionLegendComponent } from '@app/components';
import { StoreService, OperationService } from '@app/services';
import { StoreDirectory, OperationCard } from '@app/models';

@Component({
    selector: 'app-store-list',
    templateUrl: './list.component.html',
    styleUrls: ['./list.component.scss'],
    imports: [
        IonSpinner, IonGrid, IonRow, IonCol, 
        IonInfiniteScroll,  IonInfiniteScrollContent, 
        forwardRef(() => MarvButtonComponent), forwardRef(() => MarvDrawerComponent), forwardRef(() => MarvCircleComponent), forwardRef(() => MarvMessageComponent),
        forwardRef(() => MarvInputComponent), ReactiveFormsModule, TranslatePipe, 
        forwardRef(() => StoreItemComponent), forwardRef(() => StoreFiltersComponent), forwardRef(() => TypeMissionLegendComponent)
    ]
})
export class StoreListComponent  implements OnInit {

    @Input({alias : 'displayNbInterventions', required : false}) displayNbInterventions: boolean = false;
    @Output() onSelectStore = new EventEmitter<StoreItem>();
    
    @ViewChild('drawerStoreFilters') drawerStoreFilters: MarvDrawerComponent;

    isFetching: boolean = false;    
    maxStoresDisplayed: number = 50;
    indexStoreDisplayed: number = 0;
    disabledInfiniteScroll: boolean = false;
    operations: Array<OperationCard> = [];
    stores: Array<StoreDirectory> = [];
    storesToDisplay: Array<StoreDirectory> = [];
    storesDisplayed: Array<StoreItem> = [];
    storeFiltersValues: StoreFiltersValues = new StoreFiltersValues();
    FromStoreDirectory = StoreItem.FromStoreDirectory;    

    quickSearchForm: FormGroup = new FormGroup({
        store: new FormControl(null),
    });
    updateStoreSubscription: Subscription;
    updateSearchTimeout: any;
     
    constructor(        
        
    ) { }

    ngOnInit() {
        
        this.updateStoreSubscription = this.quickSearchForm.controls['store'].valueChanges.subscribe(value => {
            if(this.updateSearchTimeout){
                clearTimeout(this.updateSearchTimeout);
            }
            this.updateSearchTimeout = setTimeout(async () => {
                this.filterStoresDisplayed();
            }, 500);
            
        });  
        
        this.getStores();
    }
    
    ngOnDestroy() {
        if(this.updateStoreSubscription){
            this.updateStoreSubscription.unsubscribe();
        }
    }
    
    async getStores() {
        this.isFetching = true;
        this.operations = OperationService.Operations;
        this.stores = StoreService.Stores; 
        this.filterStoresDisplayed();
        this.isFetching = false;
    }
    
    getStoresDisplayed(){
        let subArray = this.storesToDisplay.slice(this.indexStoreDisplayed, this.indexStoreDisplayed+this.maxStoresDisplayed);
        if(subArray.length > 0){
            let storesItems: Array<StoreItem> = [];
            subArray.forEach(s => {
                storesItems.push(StoreItem.FromStoreDirectory(s));
            });
            this.storesDisplayed = this.storesDisplayed.concat(storesItems);
            this.indexStoreDisplayed += subArray.length;
        }
        else{
            this.disabledInfiniteScroll = true;
        }
    }
    
    filterStoresDisplayed() {
        
        this.isFetching = true;
        this.storesDisplayed = [];
        this.indexStoreDisplayed = 0;
        this.disabledInfiniteScroll = false;   
        
        let quickSearchStore = this.quickSearchForm.controls['store'].value || '';
        let regexQuickSearchStore = new RegExp(quickSearchStore, "i");   
         
        if(this.storeFiltersValues.nbFiltersFilled > 0 || quickSearchStore != ''){
            this.storesToDisplay = this.stores.filter(store => {
                let check: boolean = false;
                let liveOperationsIds = store.liveOperations?.map((o => o.id)) || [];               
                if( (!this.storeFiltersValues.storesCodes || this.storeFiltersValues.storesCodes.indexOf(store.code) !== -1)
                    && (!this.storeFiltersValues.city || store.address?.city?.match(new RegExp(this.storeFiltersValues.city,'gi')))
                    && (!this.storeFiltersValues.retailersCodes || this.storeFiltersValues.retailersCodes.indexOf(store.retailer?.code) !== -1)
                    && (!this.storeFiltersValues.areasIds || (store.customerArea && this.storeFiltersValues.areasIds.indexOf(store.customerArea) !== -1))
                    && (!this.storeFiltersValues.sectorsIds || (store.customerSector && this.storeFiltersValues.sectorsIds.indexOf(store.customerSector) !== -1))
                    && (!this.storeFiltersValues.withOperationId || liveOperationsIds.indexOf(this.storeFiltersValues.withOperationId) !== -1)
                    && (!this.storeFiltersValues.withoutOperationId || liveOperationsIds.indexOf(this.storeFiltersValues.withoutOperationId) === -1) 
                    && (quickSearchStore == '' || regexQuickSearchStore.test(store.name) || regexQuickSearchStore.test(store.code))               
                ){
                    check = true;
                }                
                return check;
            });
        }
        else{
            this.storesToDisplay = this.stores;
        }
        
        this.getStoresDisplayed();
        this.isFetching = false;
    }
    
    onIonInfinite(event: InfiniteScrollCustomEvent) {        
        this.getStoresDisplayed();
        event.target.complete();
    }
    
    showStoresFilters() {
        this.drawerStoreFilters.open();
    }
        
    onDidDismissDrawerFilters($event: any){
        if($event.detail?.data?.resetDrawer){
            let t = this.storeFiltersValues;
            this.storeFiltersValues = new StoreFiltersValues();
            setTimeout(() => {
                this.storeFiltersValues = t;
            });            
        }      
    }
    
    onChangeStoreFilters(storeFiltersValues: StoreFiltersValues){
        this.storeFiltersValues = storeFiltersValues;
        this.filterStoresDisplayed();
        this.drawerStoreFilters.close(false);
    }
    
    selectStore(storeItem: StoreItem){
        this.onSelectStore.emit(storeItem);
    }
    
}
